import { Tooltip } from "@edgetier/components";
import { formatUnderscoreName } from "@edgetier/utilities";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FunctionComponent, memo } from "react";

import "./permission-summary.scss";
import { IProps } from "./permission-summary.types";

/**
 * Summary details for permission
 * @param props.permission      Information about permission
 */
const PermissionSummary: FunctionComponent<IProps> = ({ permission, permissionDescription }) => (
    <div className="permission-summary">
        <div className="permission-summary__title">{formatUnderscoreName(permission.permission)}</div>

        {typeof permissionDescription === "string" && permissionDescription !== "" && (
            <Tooltip content={permissionDescription} useArrow>
                <div className="permission-summary__description-info">
                    <FontAwesomeIcon icon={faInfoCircle} />
                </div>
            </Tooltip>
        )}
    </div>
);

export default memo(PermissionSummary);
